import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';


export class ApiTranslateLoader implements TranslateLoader {

    constructor(
        private http: HttpClient
    ) {}

    getTranslation(lang: string): Observable<any> {
            return this.http.get(`/assets/i18n/fr.json`);
    }
}
